"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areCatalogsValid = exports.removeCatalog = exports.addNewCatalog = void 0;
const supergraph_api_1 = require("@hotelplan/supergraph-api");
const addNewCatalog = (nextCatalog, currentCatalogs) => {
    return currentCatalogs.slice(0).concat(nextCatalog);
};
exports.addNewCatalog = addNewCatalog;
const removeCatalog = (catalogToRemove, currentCatalogs) => {
    return currentCatalogs.filter(c => c.id !== catalogToRemove.id);
};
exports.removeCatalog = removeCatalog;
const areCatalogsValid = (catalogs) => {
    if (catalogs.length > 5)
        return false;
    const { catalogues } = catalogs.reduce((acc, catalog) => {
        if (catalog.type === supergraph_api_1.FdrCatalogType.Catalogue) {
            acc.catalogues += 1;
        }
        else if (catalog.type === supergraph_api_1.FdrCatalogType.Flyer) {
            acc.flyers += 1;
        }
        return acc;
    }, { catalogues: 0, flyers: 0 });
    if (catalogues > 3)
        return false;
    return true;
};
exports.areCatalogsValid = areCatalogsValid;
//# sourceMappingURL=fdr-catalogs-content.utils.js.map